module.exports = __webpack_public_path__ + "static/media/GPremium-pic-brand.1b079c7e.png";